<template>
  <div class="capacity-module-container">
    <div class="capacity-module-top">
      <div style="display: flex; align-items: center">
        <strong>数据存储空间</strong>
        <el-popover placement="right" width="230" trigger="hover">
          <div>
            <div>扩容相关事宜请拨打联系电话：</div>
            <a href="tel:4007700140"
              ><strong style="color: rgba(0, 0, 0, 0.84)"
                >400-770-0140</strong
              ></a
            >
          </div>
          <el-link
            slot="reference"
            style="margin-left: 20px; color: #6c85ff"
            type="primary"
            :underline="false"
            >扩容></el-link
          >
        </el-popover>
      </div>
    </div>
    <div class="capacity-module-middle" v-loading="loading">
      <div class="capacity-module-filter">
        <div class="timecategory-group" style="margin: 0 15px">
          <el-radio-group v-model="timecategory" @change="getData">
            <el-radio-button label="7">
              <span>周</span>
            </el-radio-button>
            <el-radio-button label="30">
              <span>月</span>
            </el-radio-button>
            <el-radio-button label="365">
              <span>年</span>
            </el-radio-button>
          </el-radio-group>
        </div>
        <button type="button" class="refresh-btn" title="刷新" @click="getData">
          <i class="el-icon-refresh"></i>
        </button>
      </div>
      <div class="capacity-module-content">
        <div class="capacity-module-charts">
          <div class="capacity-module-chart left" style="position: relative">
            <div class="capacity-module-chart" ref="doughnutChart"></div>
            <div class="doughnut-chart-label" v-if="used">
              <strong>{{ used }}G/{{ total }}G</strong>
              <span>已使用{{ getPercentage }}</span>
            </div>
          </div>
          <div class="capacity-module-chart right" ref="lineChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import c from "@/utils/common";
export default {
  data() {
    return {
      daterange: "",
      timecategory: 7,
      used: null,
      total: null,
      loading: false,
    };
  },
  computed: {
    getPercentage() {
      return Math.floor((this.used / this.total) * 10000) / 100 + "%";
    },
  },
  mounted() {
    this.doughnutChart = echarts.init(this.$refs.doughnutChart);
    this.lineChart = echarts.init(this.$refs.lineChart);
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      var statApi = this.$apis.storagestat;
      const endTime = new Date().getTime() - 1000 * 60 * 60 * 24;
      const startTime = endTime - this.timecategory * 1000 * 60 * 60 * 24;
      this.$axios
        .get(statApi, {
          params: {
            startTime: c.formatTime(startTime, "Y/M/D"),
            endTime: c.formatTime(endTime, "Y/M/D"),
          },
        })
        .then(
          (response) => {
            if (response.status === 200 && response.data) {
              var result = response.data;
              if (result.code === 200) {
                if (result.data) {
                  const total = (this.total = result.data.storageLimit);
                  const dayadd = result.data.dayAddSize || 0;
                  const used = (this.used = result.data.allSize || 0);
                  this.initDoughnutChart(
                    Math.floor((used - dayadd) * 100) / 100,//前天已使用的
                    used,//昨日已使用的
                    total,//总容量
                  );
                  this.initLineChart(result.data.dayDatas);
                }
              } else {
                console.log("物联网设备统计数据查询失败:" + result.message);
              }
            } else {
              console.log("物联网设备统计数据查询失败:" + response.message);
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            console.log("物联网设备统计接口调用失败:" + error.message);
          }
        );
    },
    initDoughnutChart(bused, used, total) {
      // const chartoption = {
      //   tooltip: {
      //     show: false,
      //   },
      //   legend: {
      //     bottom: "0",
      //     left: "center",
      //     itemWidth: 14,
      //     itemHeight: 14,
      //     itemGap: 30,
      //     icon: "circle",
      //     textStyle: {
      //       color: "#3C414F",
      //     },
      //     data: ["昨日新增", "已使用", "未使用"],
      //   },
      //   series: [
      //     {
      //       name: "储存空间",
      //       type: "pie",
      //       center: ["50%", "55%"],
      //       radius: ["45%", "60%"],
      //       silent: false,
      //       selectedOffset: 0,
      //       label: {
      //         show: false,
      //         position: "center",
      //       },
      //       emphasis: {
      //         disabled: true,
      //         label: {
      //           show: true,
      //           fontSize: "20",
      //         },
      //       },
      //       labelLine: {
      //         show: false,
      //       },
      //       data: [
      //         {
      //           value: used,
      //           name: "已使用",
      //           itemStyle: {
      //             color: "#5AC951",
      //           },
      //         },
      //         {
      //           value: dayadd,
      //           name: "昨日新增",
      //           itemStyle: {
      //             color: "#6C85FF",
      //           },
      //         },
      //         {
      //           value: notused,
      //           name: "未使用",
      //           itemStyle: {
      //             color: "#F0F0F0",
      //           },
      //         },
      //       ],
      //     },
      //   ],
      // };
      const chartoption = {
        angleAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: "dataMin",
          max: "dataMax",
        },
        radiusAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        polar: {
          center: ["50%", "55%"],
          radius: "60%",
        },
        series: [
          {
            type: "bar",
            data: [0, 0, 0, bused],
            coordinateSystem: "polar",
            barGap: "-100%",
            name: "已使用",
            color: "#5AC951",
            roundCap: true,
            z: 3,
          },
          {
            type: "bar",
            data: [0, 0, 0, used],
            coordinateSystem: "polar",
            name: "昨日新增",
            roundCap: true,
            barGap: "-100%",
            color: "#6C85FF",
            z: 2,
          },
          {
            type: "bar",
            data: [0, 0, 0, total],
            coordinateSystem: "polar",
            name: "未使用",
            roundCap: true,
            barGap: "-100%",
            color: "#F0F0F0",
            z: 1,
          },
        ],
        legend: {
          bottom: "0",
          left: "center",
          itemWidth: 14,
          itemHeight: 14,
          itemGap: 30,
          icon: "circle",
          selectedMode:false,
          textStyle: {
            color: "#3C414F",
          },
          data: ["昨日新增", "已使用", "未使用"],
        },
      };
      this.doughnutChart.setOption(chartoption, true, true);
    },
    initLineChart(datas) {
      const xAxisData = [];
      const serieData = [];
      datas.map((item) => {
        //xAxisData.push(item.dayTime);
        serieData.push([item.dayTime, item.allSize, item.dayAddSize]);
      });
      const chartoption = {
        tooltip: {
          trigger: "axis",
          formatter: (param) => {
            return (
              "<strong>" +
              param[0].value[0] +
              "</strong><br/>已使用" +
              param[0].value[1] +
              "GB<br/>新增" +
              param[0].value[2] +
              "GB"
            );
          },
        },
        grid: {
          top: "60",
          left: "20",
          right: "20",
          bottom: "8",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          //data: xAxisData,
          axisTick: {
            lineStyle: {
              color: "#E2E4E7",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#E2E4E7",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#6E7079",
              fontSize: 13,
            },
          },
          z: 1,
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            formatter: "{value} GB",
            textStyle: {
              color: "#3C414F",
              fontSize: 12,
            },
          },
          splitLine: {
            lineStyle: {
              color: ["#E2E4E7"],
              type: "dashed",
            },
          },
        },
        series: {
          name: "实时车流量",
          type: "line",
          showSymbol: false,
          itemStyle: {
            color: "#6C85FF",
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0.5,
              y: 1,
              x2: 0.5,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "#ffffff",
                },
                {
                  offset: 1,
                  color: "#6C85FF",
                },
              ],
            },
            opacity: 0.5,
          },
          lineStyle: {
            color: "#6C85FF",
            shadowColor: "rgba(0,0,0,0.07)",
            shadowBlur: 8,
            shadowOffsetY: 4,
          },
          data: serieData,
        },
      };
      this.lineChart.setOption(chartoption, true, true);
    },
  },
};
</script>


<style scoped>
.doughnut-chart-label {
  position: absolute;
  left: 0;
  top: 50px;
  bottom: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #000;
  font-size: 21px;
  line-height: 30px;
  pointer-events: none;
}
.doughnut-chart-label span {
  color: #999999;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/view/iot/components/capacityRoom.vue